module.exports = __webpack_public_path__ + "img/6da1d22.jpg";